<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800">
    <template v-slot:title>{{ title }}</template>
    <v-row>
      <v-col>
        <v-text-field
          label="Name"
          v-model="description"
          :outlined="outlinedInputs"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Nominal Code"
          v-model="nominalCode"
          :outlined="outlinedInputs"
          hide-details
        />
      </v-col>

      <v-col>
        <taxes-list-select v-model="taxCode" :outlined="outlinedInputs" />
      </v-col>
      <v-col v-if="false">
        <rate-type-list-select
          v-model="rateTypeCode"
          :outlined="outlinedInputs"
          hideNotInUse
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-checkbox label="Accommodation" v-model="isAccommodation" />
      </v-col>
      <v-col>
        <v-checkbox label="Activity" v-model="isActivity" />
      </v-col>
      <v-col>
        <v-checkbox label="Transport" v-model="isTransport" />
      </v-col>
      <v-col>
        <v-checkbox label="Travel" v-model="isTravel" />
      </v-col>
      <v-col>
        <v-checkbox label="Other" v-model="isOther" />
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <div v-if="debug">
      <code>
        {{ isValid }}:
        {{ value }}
      </code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import RateTypeListSelect from "../../shared/RateTypeListSelect.vue";
import TaxesListSelect from "../../shared/TaxesListSelect.vue";
export default {
  name: "charge-type-dialog",
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  components: { BasicDialog, TaxesListSelect, RateTypeListSelect },

  data() {
    return {
      debug: false,
      description: this.value ? this.value.description : "New Charge Type",
      isAccommodation: this.value ? this.value.isAccommodation : false,
      isActivity: this.value ? this.value.isActivity : false,
      isOther: this.value ? this.value.isOther : false,
      isTransport: this.value ? this.value.isTransport : false,
      isTravel: this.value ? this.value.isTravel : false,
      nominalCode: this.value ? this.value.nominalCode : "",
      rateTypeCode: this.value ? this.value.rateTypeCode : "",
      taxCode: this.value ? this.value.taxCode : "",
      perItem: false,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    title() {
      return this.value && this.value.id ? this.description : "New Charge Type";
    },
    isValid() {
      return (
        this.description &&
        this.description != "" &&
        this.taxCode &&
        this.taxCode != ""
      );
    },
  },

  watch: {
    value(newVal) {
      this.description = newVal.description;
      this.isAccommodation = newVal.isAccommodation;
      this.isActivity = newVal.isActivity;
      this.isOther = newVal.isOther;
      this.isTransport = newVal.isTransport;
      this.isTravel = newVal.isTravel;
      this.nominalCode = newVal.nominalCode;
      this.rateTypeCode = newVal.rateTypeCode;
      this.taxCode = newVal.taxCode;
    },
  },

  methods: {
    onRateTypeChange(payload) {
      console.log("onRateTypeChange", payload);
    },
    onSave() {
      this.$emit("input", {
        id: this.value.id ? this.value.id : undefined,
        description: this.description,
        isAccommodation:
          this.isAccommodation && this.isAccommodation.toString() == "true",
        isActivity: this.isActivity && this.isActivity.toString() == "true",
        isOther: this.isOther && this.isOther.toString() == "true",
        isTransport: this.isTransport && this.isTransport.toString() == "true",
        isTravel: this.isTravel && this.isTravel.toString() == "true",
        nominalCode: this.nominalCode,
        rateTypeCode: this.rateTypeCode,
        taxCode: this.taxCode,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/ChargeTypeDialog.vue